import Vue from 'vue'
import vuex from 'vuex'
Vue.use(vuex);

import Collapse from './module/Collapse.js'
import User from './module/User.js'
import MgrData from './module/updateMgrData'
import ReportData from './module/updateReportData'
import Loading from './module/Loading'
import Title from './module/Title'


export default new vuex.Store({
  modules: {
    Collapse,
    User,
    MgrData,
    ReportData,
    Loading,
    Title
  }
})